gsap.registerPlugin(ScrollTrigger);

// Global ResizeObserver for ScrollTrigger
const resizeObserver = new ResizeObserver(() => ScrollTrigger.refresh());
resizeObserver.observe(document.body);

// window.addEventListener('load', () => {
//   ScrollTrigger.refresh();
// });

if (window.innerWidth >= 992) {
const lenis = new Lenis();

// lenis.on('scroll', (e) => {
//   console.log(e)
// })

lenis.on("scroll", ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);

// lenish
}



var parallax_img = gsap.utils.toArray(".vehicle-gallery");

parallax_img.forEach((text, index) => {
  var moveUpElements = text.querySelectorAll("[move_img='up']");
  moveUpElements.forEach((element) => {
    gsap.to(element, {
      y: "20%",
      duration: 0.5,
      ease: "power1.out",
      scrollTrigger: {
        trigger: text,
        // markers: true,
        start: "top 80%",
        end: "100% 5%",
        scrub: 0.2,
        // toggleActions: "play reverse play reset",
      },
    });
  });
});

parallax_img.forEach((text, index) => {
  var moveDownElements = text.querySelectorAll("[move_img='down']");
  moveDownElements.forEach((element) => {
    gsap.to(element, {
      y: "-20%",
      duration: 0.5,
      ease: "power1.out",
      scrollTrigger: {
        trigger: text,
        // markers: true,
        start: "top 80%",
        end: "100% 5%",
        scrub: 0.2,
        // toggleActions: "play reverse play reset",
      },
    });
  });
});

// Text reveal animation
const text = document.querySelector("#splitText");
const words = text.textContent.trim().split(" ");

// Wrap each word and its characters in spans
text.innerHTML = words
  .map(
    (word) =>
      `<span class="word">${[...word]
        .map((char) => `<span class="char">${char}</span>`)
        .join("")}</span>`
  )
  .join(" ");

// Create timeline for character animation inside each word
const tl = gsap.timeline({
  scrollTrigger: {
    trigger: ".splitText-section",
    start: "center 80%",
    end: "center 20%",
    scrub: 1,
    //markers: true,
  },
});

gsap.set(".char", { opacity: 0.1 });

tl.to(".char", {
  opacity: 1,
  duration: 1,
  stagger: {
    each: 0.5, // Animation delay for each character within a word
    from: "start",
  },
});


// RANDYS Advantage Animation - Consolidated Version
// Modified version with last .timeline_text height exclusion
let advantageTimeline;
let scrollTrigger;
let scrollDistance;

function setupAnimations() {
  // Clear previous instances if they exist
  if (advantageTimeline) advantageTimeline.kill();
  if (scrollTrigger) scrollTrigger.kill();

  const isDesktop = window.innerWidth >= 992;
  const timelineWrapper = document.querySelector('.timeline-wrapper');
  const timelineContent = document.querySelector('.timeline-wrapper .timeline-scroll');
  const container = document.querySelector('.advantage-section-pin');
  const lastTextElement = document.querySelector('.timeline-item:last-child');
  
  // Calculate the height to exclude (last text element + some margin)
  const excludedHeight = lastTextElement ? lastTextElement.offsetHeight - 20 : 0; // 20px margin

  if (isDesktop) {
    // Desktop setup
    scrollDistance = (timelineContent.scrollHeight - timelineWrapper.offsetHeight) + 120;
    const pinDuration = scrollDistance / (window.innerHeight * 0.8);

    // Create pinning timeline
    advantageTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: ".advantage-section-pin",
        start: "top 5%",
        end: `+=${scrollDistance} 0%`,
        scrub: 1,
        // markers: true,
        pin: true,
        pinSpacing: true,
        onEnter: () => container.style.height = `${scrollDistance + timelineWrapper.offsetHeight}px`,
        onLeaveBack: () => container.style.height = '',
      },
    });

    // Auto-scroll the timeline content
    scrollTrigger = ScrollTrigger.create({
      trigger: ".advantage-section-pin",
      start: "top 5%",
      end: `+=${scrollDistance} 0%`,
      scrub: 1,
      invalidateOnRefresh: true,
      onUpdate: self => {
        const progress = self.progress;
        gsap.set(".timeline-wrapper .timeline-scroll", { 
          y: -scrollDistance * progress,
          ease: "none"
        });
      }
    });
  } else {
    // Mobile setup
    advantageTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: ".advantage-section-pin",
        start: "10% 80%",
        end: "50% 20%",
        scrub: 1,
      // markers: true,
        pin: false
      },
    });
  }

  // Common animation for both desktop and mobile
  advantageTimeline.set(
    ".timeline-after",{
      // Subtract the excluded height from the total
      height: `calc(100% - ${excludedHeight}px)`,
    }
  );

  advantageTimeline.fromTo(
    ".timeline-before",
    { height: "0%" },
    {
      // Subtract the excluded height from the total
      height: `calc(100% - ${excludedHeight}px)`,
      ease: "none",
      duration: isDesktop ? scrollDistance / (window.innerHeight * 0.8) : 0.8,
      onUpdate: function() {
        const line = document.querySelector(".timeline-before");
        const circles = document.querySelectorAll(".timeline-circle");
        const lineBottom = line.getBoundingClientRect().bottom - 1;
        const showClass = "show";

        circles.forEach((circle) => {
          const circleTop = circle.getBoundingClientRect().top;
          const checkmark = circle.querySelector(".checkmark");

          if (lineBottom >= circleTop) {
            circle.style.borderColor = "#F26122";
            circle.style.backgroundColor = "#F26122";
            checkmark.style.opacity = 1;
            circle.parentElement.classList.add(showClass);
          } else {
            circle.style.borderColor = "#D3D2D2";
            circle.style.backgroundColor = "#ffffff";
            checkmark.style.opacity = 0;
            circle.parentElement.classList.remove(showClass);
          }
        });
      },
    }
  );
}

// Initial setup
setupAnimations();

// // Handle resize events with debounce
// let resizeTimeout;
// window.addEventListener("resize", () => {
//   clearTimeout(resizeTimeout);
//   resizeTimeout = setTimeout(() => {
//     setupAnimations();
//     ScrollTrigger.refresh();
//   }, 100);
// });

// Refresh ScrollTrigger after images load



gsap.from(".global-media-banner-animation .group-block .group-block", {
  scrollTrigger: {
    trigger: ".global-media-banner-animation",
    start: "top 80%",
    end: "top 0%",
    toggleActions: "play none none reverse",
    //markers: true,
  },
  opacity: 0,
  y: 100,
  duration: 0.6,
  stagger: 0.2, // this will stagger one by one
  ease: "power2.out",
});